import { EVENTS } from '../constants/webSocketConsts/events';
import {
  UpdateExtensionItemsAction,
  DeleteExtensionItemsAction,
} from '../store/dashboard/actions';

const ExtensionItemHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return UpdateExtensionItemsAction(items);
    case EVENTS.REMOVE: {
      const deletedItemIds = items.map(chan => chan.id);
      return DeleteExtensionItemsAction(deletedItemIds, false);
    }
    default:
      break;
  }
  return null;
};

export default ExtensionItemHandler;
